import { withHTMLComponent } from '@updater-legacy/components/custom-element';
import { initializeRouter, CONTENT_SLOT } from './router';
import { VIEW } from '@updater-core/lib/tracker';
import '@updater-components/loading-spinner';

const styles = `
  .banner {
    color: white;
    background-color: #80acc2;
    padding: 0.5em;
    text-align: center;
  }

  a {
    color: white;
    font-weight: 900;
    text-decoration: none;
  }

  :host {
    margin-bottom: 2em;
    display: block;
  }

  @media (max-width: 775px) {
    .banner {
      display: none;
    }
  }
`;

const html = `
  <div id="${CONTENT_SLOT}">
    <upd-loading-spinner
      style="font-size: 4em; margin: 1.8em auto 1.65em auto; display: block; width: 1em;"
    >
    </upd-loading-spinner>
  </div>
`;

const withTimeout = (fn) => (...args) =>
  new Promise((resolve) => setTimeout(() => resolve(fn.apply(fn, args))));

class HomeSecurityApp extends withHTMLComponent(styles, html)() {
  static props = ['value'];

  connected() {
    this.addEventListener('routechange', this.onRouteChange);
  }

  updated({ value }) {
    this.tracker = value.tracker;
    this.router = initializeRouter(this.shadowRoot, value);
    this.router.goTo = withTimeout(this.router.goTo);

    this.router.init();
  }

  disconnected() {
    this.removeEventListener('routechange', this.onRouteChange);
  }

  onRouteChange = ({
    detail: {
      config: { data: { analytics } = {} },
    },
  }) => {
    const { event, properties = () => {} } = analytics;
    Promise.resolve(properties(this._store)).then((properties) => {
      this.tracker.track({
        verb: VIEW,
        object: event,
        details: properties,
      });
    });
  };
}

customElements.define('upd-home-security', HomeSecurityApp);
